import star3dSmPng from '/img/icons/star.png';
import star3dSmWebp from '/img/icons/star.webp';
import star3dLargePng from '/img/icons/star-large.png';
import star3dLargeWebp from '/img/icons/star-large.webp';

export const starImages = {
  star3d: {
    png: star3dSmPng,
    webp: star3dSmWebp,
  },
  star3dLg: {
    png: star3dLargePng,
    webp: star3dLargeWebp,
  },
};
